import { Container, IContainer } from "./Container"
import { IJob } from "./Job"
import { OutagePeriod, IPeriod, Period } from "./Period"
import { TimeGrid } from "./TimeGrid"


export interface IResource {
    _id: string
    outages: OutagePeriod[]
    time_grid: TimeGrid | undefined
    jobs: IJob[]
    job_index(job: IJob): number | undefined
    recalc(planningPeriod: IPeriod, downtimes: OutagePeriod[]): void
    log_jobs(job: IJob | undefined): void
}

export class Resource extends Container implements IContainer, IResource {
    outages: OutagePeriod[] = []
    _jobs: IJob[] = []
    time_grid: TimeGrid | undefined;

    get jobs() { return this._jobs }


    job_index(job: IJob): number | undefined {
        const index = undefined
        const len = this.jobs.length


        for (let index = 0; index < len; index++) {
            if (job._id == this.jobs[index]._id) {
                return index
            }
        }
        return undefined;
    }

    log_jobs(job0: IJob | undefined) {
        let jobid = ""
        if (job0) jobid = job0._id
        let str = "["
        for (const job of this.jobs) {
            str += job._id + ':' + Period.format_hour(job.startTime)
            if (job._id == jobid) str += "*"
            str += ",  "
        }
        str += "]"
        console.log(str)
    }

    recalc(planningPeriod: IPeriod, downtimes: OutagePeriod[]) {

        this.time_grid = new TimeGrid()
        this.time_grid.prepare(planningPeriod, downtimes);
        console.log("****************** time_grid", this.time_grid)
        const sortedDowntimes = downtimes.sort((a, b) => a.startTime.getTime() - b.startTime.getTime());
        //const sortedJobs = this.jobs.sort((a, b) => a.startTime.getTime() - b.startTime.getTime());
        const sortedJobs = this.jobs

        if (sortedJobs[0]) sortedJobs[0].startTime = new Date(planningPeriod.startTime)

        let start_time = sortedJobs[0] ? sortedJobs[0].startTime : new Date()

        for (const job of sortedJobs) {

            job.startTime = start_time;
            job.added_duration = 0;

           
            const overlapping_downtimes = Period.overlapping_periods(job, sortedDowntimes)
            for (const downtime of overlapping_downtimes) {
                job.added_duration += downtime.duration
            }

            job.endTime = Period.add_minutes(job.startTime, job.duration + job.added_duration);

            start_time = Period.add_minutes(job.endTime, 1);
        }
    }



}
